import { render, staticRenderFns } from "./PaymentProviderDisconnect.vue?vue&type=template&id=3588a372&"
import script from "./PaymentProviderDisconnect.vue?vue&type=script&lang=js&"
export * from "./PaymentProviderDisconnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports